import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './gradient-header.scss';

export function GradientHeader({ className = null }) {
  return <div className={classnames('dark-gradient-header pos-a top-0 left-0 w-100', className)} aria-hidden />;
}
GradientHeader.propTypes = {
  className: PropTypes.string,
};
